import storeApp from 'store/storeApp';
import { redirect } from 'react-router-dom';
import {
  getReturnUrlFromRequestLoader,
  getPostFlowUrl,
} from 'utils/common/route';
import { ensureUserInfoLoaded } from 'utils/loaderUtils';
import { queryBrandingNavigation } from 'hooks';
import { validateEulaFlow } from 'pages/eula/useEulaQuery';
import { validateRivirTCFlow } from 'pages/eula/check-rivir-tc/useRivirTCQuery';

export const getBasicInfoLoader =
  (queryClient) =>
  async ({ request }) => {
    const returnUrl = getReturnUrlFromRequestLoader(request) || '/';
    const dispatch = storeApp.dispatch;

    try {
      // Handle Walmart authorization if present
      const url = new URL(request.url);
      const search = url.search;
      if (search?.includes('walmartCallbackUri=')) {
        const authorizeWalmart = {
          isWalmartAuthorize: true,
          walmartLoginUrl: search?.split('walmartCallbackUri=')?.[1],
          walmartSearchQuery: search,
        };
        window['authorizeWalmart'] = authorizeWalmart;
      }

      // ✅ Use the common utility function
      const { userInfo } = await ensureUserInfoLoaded({
        queryClient,
        returnUrl,
      });

      await validateEulaFlow({
        queryClient,
        returnUrl,
        userId: userInfo?.id,
      });

      await validateRivirTCFlow({
        queryClient,
        returnUrl,
        userId: userInfo?.id,
      });

      const { data: brandingData } =
        (await queryBrandingNavigation({
          queryClient,
          userId: userInfo?.id,
        })) ?? {};

      // ✅ Handle post flow redirect
      if (brandingData && userInfo) {
        const redirectUrl = getPostFlowUrl({
          type: 'get-basic-info',
          returnUrl,
          dispatch,
        });

        throw redirect(redirectUrl);
      }

      // This should never be reached if everything is working correctly
      return {
        userInfo,
        navigationData: brandingData,
        returnUrl,
        success: true,
      };
    } catch (error) {
      // If it's already a redirect, re-throw it
      if (error?.status === 302 || error instanceof Response) {
        throw error;
      }

      // For other errors, the utility function should have handled logout
      // But just in case, throw a login redirect
      throw redirect(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
    }
  };
